import { render } from "./modifyuserinfo.vue?vue&type=template&id=a252fd1e"
import script from "./modifyuserinfo.vue?vue&type=script&lang=js"
export * from "./modifyuserinfo.vue?vue&type=script&lang=js"

import "./modifyuserinfo.vue?vue&type=style&index=0&id=a252fd1e&lang=less"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__